import React from 'react';
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator';
import Button from '../../../components/button/Button';
import { BUTTON_TYPE } from '../../../components/button/constants';
import styles from './AllStepsSingleView.styles';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import { Theme } from '../../../components/constants';
import Switch from '../../../components/switch/Switch';

export default function AllStepsSingleView({
    pageTitle = "",
    steps = [],
    otherViewSwitchIsOpen = false,
    onSwitchToOtherViewCb = () => {},
    otherViewSwitchLabel = "Switch To Other View",
}){

    const handleSubmit = () => {
        for (let i = 0; i < steps.length - 1; i++) {
            const step = steps[i];
            if (step.submitButtonDisabled) {
                step.submitButtonDisabledInfoCb();
                return;
            }
        }
        steps[steps.length - 1]?.submitCb()
    }

    return <>
        <div>
            <div style={styles.headerRow}>
                {
                    pageTitle && <Heading type={HEADING.H1} customStyle={styles.titleCustomStyles}>
                        {pageTitle}
                    </Heading>
                }
                <div style={styles.switchContainer}>
                        <span style={styles.switchSpan}>
                            <Switch isOn={otherViewSwitchIsOpen} name={"singleViewPageSwitchOn"} switchUniqueId={"other-view-switch"} onColor={Theme.SECONDARY} handleToggleCb={onSwitchToOtherViewCb} customSwitchLabelStyle={styles.switchLabelCustomStyle} customSwitchButtonStyle={styles.switchButtonCustomStyle} />
                        </span>
                        <span style={styles.irsViewText}>{otherViewSwitchLabel}</span>
                </div>
            </div>
            {steps.map((step, index) => (
                <>
                    <div key={index}>
                        <h2>{step.title}</h2>
                        {React.cloneElement(step.stepBodyComponent, { renderForSingleView: true })}
                    </div>
                    <HorizontalSeparator style={styles.horizontalSeparatorContainer} />
                </>
            ))}
            {
                (steps.length) ? <Button style={styles.finalSubmitBtn} type={BUTTON_TYPE.PRIMARY} onClickCb={() => handleSubmit()} children={"Submit"}/>
                : null
            }
            
        </div>
    </>
}